module.exports = __webpack_public_path__ + "static/media/circle-view-on.b5686d6f.svg";